'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.lookups', [])

.factory('loookupService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/API/Lookup';

    service.getLookups = function () {
        return $http.get(baseUrl, { cache: true })
                    .then(function (response) { return response.data; })
    };

    service.getCountries = function () {
        return $http.get('/assets/jsons/countries.json', { cache: true })
                    .then(function (response) { return response.data; })
    };

    service.getNameCountries = function () {
        return $http.get('/assets/jsons/namecountries.json', { cache: true })
                    .then(function (response) { return response.data; })
    };


    return service;
}]);
